import React from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import MainSection from "../../components/about/MainSection";
import Partners from "../../components/about/Partners";
import Team from "../../components/about/Team";
import Testimonial from "../../components/about/Testimonial";
import Divider from "@material-ui/core/Divider";
import Awards from "../../components/about/Awards";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  zeroPadding: {
    padding: 0,
  },
}));

export default function About() {
  const classes = useStyles();
  return (
    <>
      <Container maxWidth="lg" className={classes.zeroPadding}>
        <Box mt={2}>
          <MainSection />
        </Box>
        <Box mt={15}>
          <Partners />
        </Box>
        <Box mt={15}>
          <Testimonial />
        </Box>
        <Box mt={15}>
          <Team />
        </Box>
      </Container>
      <Box mt={10}>
        <Divider light />
      </Box>
      <Container maxWidth="lg" className={classes.zeroPadding}>
        <Box my={15}>
          <Awards />
        </Box>
      </Container>
    </>
  );
}
